import React from 'react';


import {createShimmerPlaceholder} from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import {RFValue} from 'react-native-responsive-fontsize';
import {useTheme} from 'styled-components/native';

const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient);

export function AchievementsShimmer() {
  const theme = useTheme();
  return (
    <ShimmerPlaceHolder
      style={{
        width: RFValue(100),
        height: RFValue(43),
        borderRadius: RFValue(12),
        opacity: 0.3,
      }}
      shimmerColors={theme.colors.shimmer_placeholder}
    />
  );
}
